import React, { useEffect, useRef, useState } from 'react';
import Buttons from '../Constans/Buttons';
import { Container, Row, Button, ButtonGroup, Input, FormGroup, Label } from 'reactstrap';
import AddressForm from '../../SaleJetBlock/Partials/AddressForm/AddressForm';
import TextInput from '../../../Shared/TextInput/TextInput';
import { validateForm, phoneValidation, mailValidation, postalCodeValidation } from '../Constans/Validation';
import CityInput from '../Constans/CityInput';
import { INPUT_TYPE, PathHistory } from '../IdfSaleEnums';
import { dwhReport, dwhDictionary } from '../dwhReports/dwhGeneralReport';
export default function PersonalInfoStepOne(props) {
  const { idfStore: store } = props;
  const [isSubmit, setIsSubmit] = useState(false);
  const renderCount = useRef(0);
  const [didTryToContinue, setDidTryToContinue] = useState(false);
  const [formErrors, setFormErrors] = useState({
    selectedEmail: false,
    // selectedPhoneNumber: false,
    mailbox: false,
    postalCode: false,
  });

  const validateFormFields = () => {
    let formData;
    if (store.personalInfoMode === 'MAILBOX')
      formData = {
        selectedEmail: { value: store.selectedEmail, type: INPUT_TYPE.EMAIL },
        // selectedPhoneNumber: {value: store.selectedPhoneNumber, type: INPUT_TYPE.PHONE},
        mailbox: { value: store.mailbox, type: INPUT_TYPE.UNKNOWN }, // Assuming mailbox field type is not specified in INPUT_TYPE
        postalCode: { value: store.postalCode, type: INPUT_TYPE.POSTAL_CODE },
      };
    if (store.personalInfoMode === 'ADDRESS')
      formData = {
        selectedEmail: { value: store.selectedEmail, type: INPUT_TYPE.EMAIL },
        // selectedPhoneNumber: {value: store.selectedPhoneNumber, type: INPUT_TYPE.PHONE},
      };
    const fieldsToValidate = Object.keys(formData);
    const errors = validateForm(formData, fieldsToValidate);
    setFormErrors(errors);
    return Object.values(errors).some((error) => error);
  };

  useEffect(() => {
    if (didTryToContinue) renderCount.current++;
    setDidTryToContinue(false);
    if (renderCount.current > 0) validateFormFields();
  }, [store.mailbox, store.selectedEmail, store.postalCode]);

  const onSubmit = async (data) => {
    const isError = validateFormFields();
    setDidTryToContinue(true);
    if (data.isValid && !isError) {
      props.setSelectedAddress(data);

      props.setCurrentStep({ current: PathHistory.PaymentInfo, previous: store.steps.current });
      props.saveToHistory(PathHistory.PaymentInfo)
    }
    setIsSubmit(false);
  };
  return (
    <div className='idf-personal-info step'>
      <Container fluid className='idf-step-header justify-content-center d-flex flex-column align-items-center'>
        <Row className='idf-title-bold justify-content-center d-flex'>{props.contentData.personalInfoTitle.value}</Row>
        <Row className='idf-line justify-content-center d-flex'></Row>
      </Container>

      <Container fluid className='address-container justify-content-center d-flex flex-column align-items-center'>
        <div className='address-header'>
          <Row className='idf-sub-title-bold justify-content-center d-flex'>כתובת</Row>
          <Row className='idf-sub-title justify-content-center d-flex'>מלאו את פרטי הכתובת או תא הדואר אליה ישויך המנוי</Row>
        </div>
        <div>
          <ButtonGroup>
            <Button outline onClick={() => props.setPersonalInfoMode('ADDRESS')} active={store.personalInfoMode === 'ADDRESS'}>
              כתובת ביתית
            </Button>
            <Button outline onClick={() => props.setPersonalInfoMode('MAILBOX')} active={store.personalInfoMode === 'MAILBOX'}>
              תא דואר
            </Button>
          </ButtonGroup>
        </div>
      </Container>
      <Container fluid className='address-container idf-address justify-content-center d-flex flex-column align-items-center'>
        {store.personalInfoMode === 'ADDRESS' ? (
          <>
            <div className='address-form'>
              <AddressForm onSubmit={onSubmit} isSubmit={isSubmit} selectedAddress={store.selectedAddress}></AddressForm>
            </div>
          </>
        ) : (
          <div className='mail-box'>
            {/* <AddressForm onSubmit={onSubmit} isSubmit={isSubmit} onlyCity={true}></AddressForm> */}
            <CityInput props={props} store={store} onSubmit={onSubmit} isSubmit={isSubmit}></CityInput>
            <div className='email-phone-form-container'>
              <TextInput
                onChange={(e) => props.setMailbox(e.target.value)}
                className={`mb-2 ${formErrors.mailbox ? 'input-error' : ''}`}
                value={store?.mailbox}
                placeholder='תא דואר'
                required='required'
                error={formErrors.mailbox && 'יש להזין תא דואר'}></TextInput>

              <TextInput
                onChange={(e) => props.setPostalCode(e.target.value)}
                className={`mb-2 ${formErrors.postalCode ? 'input-error' : ''}`}
                value={store?.postalCode}
                placeholder='מיקוד'
                required='required'
                error={formErrors.postalCode && 'יש להזין מיקוד'}></TextInput>
            </div>
          </div>
        )}
        <div className='email-phone-form-container'>
          <TextInput
            onChange={(e) => props.setSelectedEmail(e.target.value)}
            value={store?.selectedEmail}
            className={`mb-2 ${formErrors.selectedEmail ? 'input-error' : ''}`}
            placeholder='דוא"ל'
            required='required'
            error={formErrors.selectedEmail && 'יש להזין כתובת דוא"ל תקינה'}></TextInput>

          <FormGroup check inline>
            <Input
              className=''
              dir='rtl'
              type='checkbox'
              checked={store.confirmMail}
              onChange={(e) => props.setConfirmMail(e.target.checked)}
            />
            <Label check>הנני מאשר קבלת חשבונית בדוא״ל</Label>
          </FormGroup>
          <FormGroup className='sub-agreement-container' check inline>
            <Input
              className=''
              dir='rtl'
              type='checkbox'
              checked={props.idfStore.joiningForm.sub_agreement}
              onChange={(e) => props.setSubAgreement(e.target.checked)}
            />
            <Label check>
              אני מעוניין בקבלת דברי פרסומת של סלקום בנושאים שאינם שירותי תקשורת ורט"ן ואינם שירותים המתלווים להם באמצעות הודעת MMS SMS,
              מייל, פקס והודעות חיוג אוטומטיות.
            </Label>


          </FormGroup>
          <div className='error' style={{ display: 'block', marginRight: '24px', fontSize: '18px' }}>
            * (סעיף אופציונאלי – לא חובה לסמן).
          </div>
        </div>
      </Container>
      <Buttons
        isForm={true}
        setIsSubmit={setIsSubmit}
        canContinue={true}
      />
    </div>
  );
}
